<template>
  <div style="margin-top: 5px;line-height: 2.9px; white-space: pre-wrap !important;">
    <div v-for="(item, index) in initSamStatus" :key="index" style="white-space: pre-wrap !important;">
      <!-- - {{ item.channel_name }} -->
      <vs-avatar v-if="item.channel_status==1" color="success" size="small" icon="check" style="margin-top: 10px;"/>
      <vs-avatar v-else-if="item.channel_status==0" color="danger" size="small" icon="close" style="margin-top: 10px;"/>
      <vs-avatar v-else size="small" text="N/A" style="margin-top: 10px;"/>
      {{ "\n" }}
      <br/>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    name: "InitSamStatusAgGridComponent",
    data() {
      return {
        initSamStatus: [],
        initSamStatusStr: ""
      }
    },
    mounted() {
      this.initSamStatus = this.params.data.channel_module_status_array
      this.initSamStatusStr = this.params.data.channel_module_status_str
    }
  })
</script>

<style scoped>
</style>